<template>
  <div class="krs019">
    <!-- <div>
      그룹설정 용량 : {{ spaceSize.groupMaxSize }}MB<br />
      사이트설정 용량 :
      {{ spaceSize.siteMaxSize / 1024 / 1024 }}MB<br />
      그룹사용 용량 :
      {{ (spaceSize.groupUseSize / 1024 / 1024).toFixed(1) }}MB<br />
      사이트사용 용량 :
      {{ (spaceSize.siteUseSize / 1024 / 1024).toFixed(1) }}MB<br />

      <input type="text" @input="numberCheck" maxlength="6" /><button
        type="button"
        @click="updateSpaceSize"
      >
        수정
      </button>
    </div> -->
    <ul>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.ProAndPrivateManage.001","용량")}}</dt>
          <dd>
            <div v-show="state == 'VIEW'">
              <div class="txt">{{ spaceSize.groupMaxSize }}MB</div>
              <button
                type="button"
                class="btn-primary-small"
                @click="changeState"
              >
                {{$i18nUtil.trans("button.modify","수정")}}
              </button>
            </div>
            <div v-show="state == 'EDIT'">
              <div class="spacesize-box">
                <input
                  type="text"
                  @input="numberCheck"
                  v-model="spaceSize.groupMaxSize"
                  maxlength="6"
                />(MB)
              </div>

              <button
                type="button"
                class="btn-primary-small black"
                @click="updateSpaceSize"
              >
                {{$i18nUtil.trans("button.save","저장")}}
              </button>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.ProAndPrivateManage.002","사용 용량")}}(NAS)</dt>
          <dd>
            <div class="txt">
              {{ (spaceSize.groupUseSize / 1024 / 1024).toFixed(1) }}MB
            </div>
          </dd>
          <dt style="width: 200px" v-if="modalInfo.inoutKbn == 'IN'">
            {{$i18nUtil.trans("message.ProAndPrivateManage.002","사용 용량")}}(sharePoint)
          </dt>
          <dd v-if="modalInfo.inoutKbn == 'IN'">
            <div class="txt">
              {{ spaceSize.siteUseSize != undefined ? (spaceSize.siteUseSize / 1024 / 1024).toFixed(1) : 0  }}MB
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.ProAndPrivateManage.003","남은 용량")}}</dt>
          <dd>
            <div class="txt">{{ spaceSize.remainningSize.toFixed(1) }}MB</div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.ProAndPrivateManage.004","상태 설정")}}</dt>
          <dd>
            <input
              type="radio"
              name="status"
              id="status_01"
              @change="updateStatus('01')"
              value="01"
              v-model="status"
            /><label for="status_01">{{$i18nUtil.trans("message.ProAndPrivateManage.005","운영")}}</label>
            <input
              type="radio"
              name="status"
              id="status_02"
              @change="updateStatus('02')"
              value="02"
              v-model="status"
            /><label for="status_02">{{$i18nUtil.trans("message.ProAndPrivateManage.006","폐쇄")}}</label>
            <input
              v-if="modalInfo.groupKbn == 'PRO'"
              type="radio"
              name="status"
              id="status_03"
              @change="updateStatus('03')"
              value="03"
              v-model="status"
            /><label for="status_03">{{$i18nUtil.trans("message.ProAndPrivateManage.007","영구")}}</label>
            <!-- <input type="radio" name="status" id="status_04" checked /><label for="status_01">운영</label> -->
          </dd>
        </dl>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      resultSpaceSize: null,
      status: null,
      state: "VIEW",
      spaceSize: {
        groupMaxSize: 0,
        groupUseSize: 0,
        siteMaxSize: 0,
        siteUseSize: 0,
        remainningSize: 0,
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  created() {
    this.getSpaceSize();
  },
  mounted() {
    this.status = this.modalInfo.status;
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    getSpaceSize() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId: this.modalInfo.groupId,
      };
      reqData.url = "/api/cogroup/cogroup/getCogroupSpaceSize";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.spaceSize = res.result;
            // obj.spaceSize.useSize =
            //   res.result.groupUseSize + res.result.siteUseSize;
            obj.spaceSize.remainningSize =
              obj.spaceSize.groupMaxSize -
              (obj.spaceSize.groupUseSize + (obj.spaceSize.siteUseSize == undefined ? 0 : Number(obj.spaceSize.siteUseSize))) /
                1024 /
                1024;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    updateSpaceSize(e) {
      if (this.spaceSize.groupMaxSize > 102400) {
        const dialogInfo = {
          obj: this.$modal,
          component: Dialog,
          title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
          button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
          contents: obj.$i18nUtil.trans("message.ProAndPrivateManage.008","공간용량은 100GB 이상 설정할 수 없습니다."),
        };
        this.showDialog(dialogInfo);
      }

      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId: this.modalInfo.groupId,
        spaceSize: this.spaceSize.groupMaxSize.toString(),
      };
      reqData.url = "/api/cogroup/cogroup/updateCogroupSpaceSize";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            // obj.getSpaceSize();
            obj.toastInfo.message = obj.$i18nUtil.trans("message.ProAndPrivateManage.009","최대용량이 설정되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.$emit("updateSpaceSize");
            obj.state = "VIEW";
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    updateStatus(status) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId: this.modalInfo.groupId,
        status: status,
      };
      reqData.url = "/api/cogroup/cogroup/updateCogroupStatus";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.ProAndPrivateManage.010","공간 상태가 변경되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.$emit("updateSpaceSize");
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    numberCheck(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    },
    changeState(e) {
      this.state = "EDIT";
    },
  },
};
</script>

<style scoped>
.spacesize-box {
  width: 210px;
}
.spacesize-box input {
  height: 21px;
  padding: 0 0 0 5px;
  line-height: 21px;
  color: #000;
  border: 0 none;
}
.krs019 > ul > li > dl > dt {
  width: 150px;
}
.krs019 > ul > li:nth-child(1) > dl > dd {
  width: 1030px;
}
.krs019 > ul > li > dl > dd {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/ProAndPrivateManage.vue